<template>
  <div class="dropdown d-inline ">
    <soft-button id="navbarDropdownMenuLink2" color="primary" variant="outline" class='dropdown-toggle ms-2' 
      data-bs-toggle="dropdown" aria-expanded="false" :class="[isSelected ? 'active-filter' : '']" >{{ $t('key_filters_date') }}</soft-button>

    <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink2" style="min-width: 250px;">
      <form ref="formDate" class="px-4 py-3 .needs-validation" >
        <div class="mb-3">
          <label class="form-label text-primary">{{ $t('key_filters_date_start_date') }} <span style="color:red">*</span> </label>
          <input v-model="localDates.start" class="form-control" type="date" required @change="handleClick()" @input="validateDateField($event)"/>
          <div id="start-date-message" class="invalid-feedback">
            {{ $t('key_filters_date_start_date_error') }}
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label text-primary">{{ $t('key_filters_date_end_date') }} <span style="color:red">*</span> </label>
          <input v-model="localDates.end" class="form-control" type="date" required @change="handleClick()" @input="validateDateField($event)"/>
          <div id="start-date-message" class="invalid-feedback">
            {{ $t('key_filters_date_end_date_error') }}
          </div>
        </div>
      </form>
      <hr class="horizontal my-2" />
      <button class="dropdown-item border-radius-md text-primary " type="button" @click="getFechaHoy()">{{ $t('key_filters_date_today_date') }}</button>
      <button class="dropdown-item border-radius-md text-danger" type="button" @click="cleanFilters()">{{ $t('key_filters_clear_filters') }}</button>
    </div>
  </div>
</template>

<script>

  import SoftButton from "@/components/SoftButton.vue";

  export default {
    name:"FilterDate",
    components: {
      SoftButton
    },
    props: {
      valueDate: {
        type: Object,
        default: () => {return{start: '', end:''}},
      },
    },
    emits: ['filter-change', 'input', 'clean-filter-date'],
    data() {
      return {
        localDates: this.valueDate
      }
    },
    computed: {
      isSelected() {
        return this.localDates.start!= '' || this.localDates.end !='';
      }
    },
    watch: {
      localDates(newValue) {
        this.$emit("input", newValue);
      },
      valueDate(newValue) {
        this.localDates = newValue;
      },
    },
    mounted(){
    },
    methods: {
      cleanFilters() {
        this.$emit('clean-filter-date')
      },
      handleClick() {
        let form = this.$refs.formDate;
        if(form.checkValidity() ){
        this.$emit('filter-change',this.localDates);
      }
      },
      getFechaHoy(){
        const fecha = new Date();
        this.localDates.start= this.$dateUtils.toFormat(fecha,'yyyy-MM-DD')
        this.localDates.end= this.$dateUtils.toFormat(fecha,'yyyy-MM-DD')
        this.$emit('filter-change',this.localDates)
      },
      validateDateField($event){
        let value = $event.target.value;
        let form = this.$refs.formDate;
        if(value==''){
          $event.target.classList.add("is-invalid")
          form.classList.remove('was-validated')
          return
        }
        $event.target.classList.remove("is-invalid")
      }
    }
  }

</script>

<style scoped>

  .active{
    background-color: rgb(234, 244, 247) !important;
  }
  .active-filter {
    color: #fff;
    background-color: #42695c;
    border-color: #42695c;
  }
  .dropdown-menu {
    width:100%;
  }
  .was-validated .form-control:invalid, .form-control.is-invalid {
    background-position: right 1.3rem center !important;
  }

</style>